import { Subject } from 'rxjs';
import { openModal } from '@core/components/ModalStack';
import { DeleteContactModalProps } from './DeleteContactModal';

export function showContactRemoveModal(props: Omit<DeleteContactModalProps, 'onSelect' | 'onCancel'>) {
  const obs$ = new Subject<boolean>();

  const onSelect = (removeEmails: boolean) => {
    obs$.next(removeEmails);
    obs$.complete();
  };

  import('./DeleteContactModal').then(module => openModal(module.DeleteContactModal, { ...props, onSelect }));

  return obs$;
}
